/* Pop-up WELKOM10 met A/B-test (19-10-2026; ontwerp v2, goedgekeurd door Jurri).
   - Groep A/B: willekeurig bij het eerste bezoek, onthouden in localStorage (pbs_ab_popup). Pas ná de cookiebanner.
   - Groep A ziet de pop-up één keer: na X seconden of bij weggaan (muis naar boven, desktop). Nooit in de configurator,
     winkelwagen, bij het afrekenen of in het account. Weggeklikt of aangemeld: 30 dagen niet meer.
   - De groep gaat als winkelwagen-kenmerk _pbs_ab mee in de bestelling (voor het dashboard).
   - Aanmelden: e-mailadres naar pdf.probikesticker.net/popup.php (→ Shopify-klant met tags), code meteen in de winkelwagen.
   Instellingen en teksten: snippets/pbs-popup.liquid (window.PBS_POPUP). */
(() => {
  const C = window.PBS_POPUP;
  if (!C || C.modus === 'uit') return;
  const T = C.t, NU = Date.now(), DAG = 864e5;
  const lees = (k) => { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } };
  const schrijf = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* privémodus */ } };
  const meld = (data) => fetch(C.server, { method: 'POST', mode: 'cors', keepalive: true, headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify(Object.assign({ site: C.site, taal: C.taal, land: C.land || '' }, data)) });
  const pad = (location.pathname.replace(/^\/(en|de|fr|es|it)(?=\/|$)/, '') || '/');
  const cfgPad = (C.configurator || '/pages/naamsticker').replace(/^\/(en|de|fr|es|it)(?=\/)/, '');
  const nietHier = pad.startsWith(cfgPad) || /^\/(cart|checkouts?|account|pages\/naamsticker)(\/|$)/.test(pad);

  function start() {
    let ab = lees('pbs_ab_popup');
    if (!ab || !/^[AB]$/.test(ab.g)) {
      ab = { g: Math.random() < 0.5 ? 'A' : 'B', id: Math.random().toString(36).slice(2) + NU.toString(36) };
      schrijf('pbs_ab_popup', ab);
    }
    const groep = C.modus === 'iedereen' ? 'A' : ab.g;
    const kenmerk = C.modus === 'iedereen' ? 'iedereen' : groep;
    // groep in de winkelwagen → staat straks in de bestelling (één keer per sessie)
    try {
      if (sessionStorage.getItem('pbs_ab_wagen') !== kenmerk) {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _pbs_ab: kenmerk } }) })
          .then((r) => { if (r.ok) sessionStorage.setItem('pbs_ab_wagen', kenmerk); }).catch(() => {});
      }
    } catch (e) { /* geen sessionStorage */ }
    // bezoek één keer per dag melden (alleen tijdens de A/B-test)
    const vandaag = new Date().toISOString().slice(0, 10);
    if (C.modus === 'ab' && ab.dag !== vandaag) { ab.dag = vandaag; schrijf('pbs_ab_popup', ab); meld({ e: 'bezoek', g: groep, id: ab.id }).catch(() => {}); }
    if (groep !== 'A' || nietHier) return;
    const st = lees('pbs_popup_status');
    if (st && st.tot > NU) return;
    let getoond = false;
    const toon = () => {
      if (getoond) return;
      if (document.querySelector('.pbs-fb')) { setTimeout(toon, 1000); return; } // nooit tegelijk met de feedbackvraag
      getoond = true;
      document.removeEventListener('mouseout', weg);
      bouw(groep, ab.id);
      if (C.modus === 'ab') meld({ e: 'getoond', g: groep, id: ab.id }).catch(() => {});
    };
    const weg = (e) => { if (!e.relatedTarget && e.clientY <= 5) toon(); };
    setTimeout(toon, (C.seconden || 15) * 1000);
    if (matchMedia('(pointer: fine)').matches) document.addEventListener('mouseout', weg);
  }

  function bouw(groep, id) {
    const stijl = document.createElement('style');
    /* Ontwerp C v4 in ijsblauw (Jurri 23-10-2026, kleurproef 3): lichte kaart, groot percentage, aanmelden = nieuwsbrief (geen vinkje).
       Kleuren via variabelen: --pop-bg (kaart), --pop-accent (kopje), --pop-zacht (kleine tekst), --pop-veld (invoerveld). */
    stijl.textContent = `
      .pbs-pop{--pop-bg:#e3f1fb;--pop-accent:#0060b0;--pop-zacht:#4d6577;--pop-veld:#fff;--pop-rand:#b7d3e8;--pop-knop:#0060b0;--pop-knop-tekst:#fff;--pop-tekst:#0b2239;--pop-groot:#0060b0;
        position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;font-family:Montserrat,"Segoe UI",Arial,sans-serif;color:var(--pop-tekst)}
      .pbs-pop__dim{position:absolute;inset:0;background:rgba(11,34,57,.55);animation:pbsIn .2s ease}
      .pbs-pop__kaart{position:relative;width:min(440px,calc(100vw - 32px));background:var(--pop-bg);border-radius:18px;box-shadow:0 24px 60px rgba(0,0,0,.4);animation:pbsOp .25s ease;text-align:center}
      .pbs-pop__inhoud{padding:36px 36px 24px;position:relative}
      .pbs-pop__x{position:absolute;right:14px;top:14px;width:34px;height:34px;border:0;border-radius:50%;background:var(--pop-x,#fff);font-size:22px;line-height:34px;color:var(--pop-tekst);cursor:pointer;padding:0}
      .pbs-pop__welkom{color:var(--pop-accent);font-weight:700;font-size:12.5px;letter-spacing:.16em;text-transform:uppercase;margin:0}
      .pbs-pop__kop{margin:10px 0 22px}
      .pbs-pop__groot{display:block;color:var(--pop-groot);font-weight:900;font-size:84px;line-height:1;letter-spacing:-.03em}
      .pbs-pop__sub{display:block;font-weight:700;font-size:18px;line-height:1.3}
      .pbs-pop form{display:grid;gap:10px}
      .pbs-pop input[type=email]{width:100%;height:52px;border:1.5px solid var(--pop-rand);border-radius:10px;padding:0 16px;font:500 16px Montserrat,Arial,sans-serif;color:#1c1c1c;background:var(--pop-veld);box-sizing:border-box}
      .pbs-pop input[type=email]::placeholder{color:var(--pop-zacht)}
      .pbs-pop input[type=email]:focus{outline:none;border-color:var(--pop-accent)}
      .pbs-pop__knop{width:100%;min-height:54px;background:var(--pop-knop);border:0;border-radius:10px;font:800 17px Montserrat,Arial,sans-serif;color:var(--pop-knop-tekst);cursor:pointer}
      .pbs-pop__knop:hover{filter:brightness(.94)}.pbs-pop__knop:disabled{opacity:.6}
      .pbs-pop__mini{font-size:12px;color:var(--pop-zacht);line-height:1.45;margin:4px 0 0}
      .pbs-pop__mini a{color:inherit}
      .pbs-pop__nee{display:inline-block;margin:12px auto 0;border:0;background:none;font:500 13px Montserrat,Arial,sans-serif;color:var(--pop-zacht);text-decoration:underline;cursor:pointer}
      .pbs-pop__fout{color:#b3261e;font-size:12.5px;min-height:0}
      .pbs-pop__fout:empty{display:none}
      .pbs-pop__hp{position:absolute;left:-9999px;width:1px;height:1px;opacity:0}
      .pbs-pop__klaar h2{font-weight:800;font-size:28px;margin:0}
      .pbs-pop__klaar p{color:var(--pop-zacht);margin:8px 0 0}
      .pbs-pop__code{margin:10px auto 8px;display:inline-flex;align-items:center;gap:12px;border:2px dashed var(--pop-tekst);border-radius:10px;padding:10px 16px;font-weight:800;font-size:24px;letter-spacing:.06em}
      .pbs-pop__code button{font:700 12px Montserrat,Arial,sans-serif;letter-spacing:0;background:var(--pop-knop);color:var(--pop-knop-tekst);border:0;padding:6px 9px;border-radius:6px;cursor:pointer}
      .pbs-pop__vinkje{color:#067647;font-weight:700;font-size:13px}
      @keyframes pbsIn{from{opacity:0}}@keyframes pbsOp{from{opacity:0;transform:translateY(12px)}}
      @media (max-width:640px){
        .pbs-pop{align-items:flex-end}
        .pbs-pop__kaart{width:100%;border-radius:20px 20px 0 0;animation:pbsSchuif .3s ease}
        .pbs-pop__inhoud{padding:22px 24px 22px}
        .pbs-pop__welkom{display:none}
        .pbs-pop__x{top:8px;right:8px;width:30px;height:30px;line-height:30px;font-size:20px}
        .pbs-pop__kop{margin:14px 0 14px;line-height:1.25}
        .pbs-pop__groot{display:inline;font-size:44px;vertical-align:baseline}
        .pbs-pop__sub{display:inline;font-size:17px;margin-left:6px}
      }
      @keyframes pbsSchuif{from{transform:translateY(100%)}}
      @media (prefers-reduced-motion:reduce){.pbs-pop__dim,.pbs-pop__kaart{animation:none}}`;
    document.head.appendChild(stijl);

    const e = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const groot = (C.code.match(/\d+\s*%?/) || ['10%'])[0];
    const pop = document.createElement('div');
    pop.className = 'pbs-pop';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-modal', 'true');
    pop.setAttribute('aria-labelledby', 'pbs-pop-titel');
    const pct = T.titel_mobiel.match(/\d+\s*%/) ? T.titel_mobiel.match(/\d+\s*%/)[0] : groot;
    pop.innerHTML = `<div class="pbs-pop__dim"></div>
      <div class="pbs-pop__kaart">
        <div class="pbs-pop__inhoud">
          <button type="button" class="pbs-pop__x" aria-label="${e(T.sluiten)}">×</button>
          <p class="pbs-pop__welkom">${e(T.titel)}</p>
          <h2 class="pbs-pop__kop" id="pbs-pop-titel"><span class="pbs-pop__groot">${e(pct)}</span> <span class="pbs-pop__sub">${e(T.korting_links)}</span></h2>
          <form class="pbs-pop__form" novalidate>
            <input type="email" name="email" autocomplete="email" inputmode="email" placeholder="${e(T.veld)}" aria-label="${e(T.veld)}" required>
            <input type="text" name="hp" class="pbs-pop__hp" tabindex="-1" autocomplete="off" aria-hidden="true">
            <div class="pbs-pop__fout" aria-live="polite"></div>
            <button type="submit" class="pbs-pop__knop">${e(T.knop)}</button>
            <p class="pbs-pop__mini">${e(T.vinkje)} <a href="${e(C.privacy)}" target="_blank" rel="noopener">${e(T.privacy)}</a></p>
          </form>
          <button type="button" class="pbs-pop__nee">${e(T.nee)}</button>
        </div>
      </div>`;
    document.body.appendChild(pop);
    const vorigeFocus = document.activeElement;
    const veld = pop.querySelector('input[type=email]');
    setTimeout(() => veld.focus({ preventScroll: true }), 50);

    const sluit = (status) => {
      if (status) schrijf('pbs_popup_status', { s: status, tot: Date.now() + 30 * DAG });
      if (status === 'weggeklikt' && C.modus === 'ab') meld({ e: 'weggeklikt', g: groep, id }).catch(() => {});
      pop.remove(); stijl.remove();
      document.removeEventListener('keydown', toets);
      if (vorigeFocus && vorigeFocus.focus) vorigeFocus.focus({ preventScroll: true });
    };
    const toets = (ev) => { if (ev.key === 'Escape') sluit(pop.dataset.klaar ? '' : 'weggeklikt'); };
    document.addEventListener('keydown', toets);
    pop.querySelector('.pbs-pop__x').addEventListener('click', () => sluit(pop.dataset.klaar ? '' : 'weggeklikt'));
    pop.querySelector('.pbs-pop__nee').addEventListener('click', () => sluit('weggeklikt'));
    pop.querySelector('.pbs-pop__dim').addEventListener('click', () => sluit(pop.dataset.klaar ? '' : 'weggeklikt'));

    pop.querySelector('form').addEventListener('submit', async (ev) => {
      ev.preventDefault();
      const f = ev.target, email = veld.value.trim(), fout = pop.querySelector('.pbs-pop__fout');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { fout.textContent = T.fout_email; veld.focus(); return; }
      fout.textContent = '';
      const knop = f.querySelector('.pbs-pop__knop');
      knop.disabled = true;
      // aanmelden (mag mislukken: de klant krijgt de code toch) en de code meteen in de winkelwagen
      await Promise.allSettled([
        // aanmelden = nieuwsbrief (Jurri 23-10-2026); de tekst onder de knop zegt dat, er is geen vinkje meer
        meld({ e: 'aanmelden', g: groep, id, email, toestemming: true, hp: f.hp.value }),
        fetch('/discount/' + encodeURIComponent(C.code), { credentials: 'same-origin' }),
      ]);
      schrijf('pbs_popup_status', { s: 'aangemeld', tot: Date.now() + 365 * DAG });
      pop.dataset.klaar = '1';
      pop.querySelector('.pbs-pop__inhoud').innerHTML = `<button type="button" class="pbs-pop__x" aria-label="${e(T.sluiten)}">×</button>
        <div class="pbs-pop__klaar"><h2 id="pbs-pop-titel">${e(T.gelukt)} 🎉</h2><p style="margin:8px 0 0">${e(T.code_label)}</p>
          <div class="pbs-pop__code">${e(C.code)} <button type="button" class="pbs-pop__kopieer">${e(T.kopieer)}</button></div>
          <div class="pbs-pop__vinkje">✓ ${e(T.klaar)}</div>
          <a class="pbs-pop__knop" style="display:flex;align-items:center;justify-content:center;text-decoration:none;margin-top:16px" href="${e(C.configurator)}">${e(T.naar_cfg)} →</a></div>`;
      pop.querySelector('.pbs-pop__x').addEventListener('click', () => sluit(''));
      pop.querySelector('.pbs-pop__kopieer').addEventListener('click', (k) => {
        (navigator.clipboard ? navigator.clipboard.writeText(C.code) : Promise.reject()).then(() => { k.target.textContent = T.gekopieerd; }).catch(() => {});
      });
    });
  }

  // pas na de cookiebanner (Shopify Customer Privacy API); zonder API meteen
  function naBanner(fn) {
    let gedaan = false;
    const een = () => { if (!gedaan) { gedaan = true; fn(); } };
    // shouldShowBanner() blijft ook ná wegklikken "true" (het zegt of de regio een banner vraagt); daarom kijken we
    // of de bezoeker al gekozen heeft (currentVisitorConsent: '' = nog niet gekozen, 'yes'/'no' = gekozen)
    const gekozen = (cp) => { try { const v = cp.currentVisitorConsent && cp.currentVisitorConsent(); return !!v && (v.marketing !== '' || v.analytics !== ''); } catch (e) { return false; } };
    let wachten = null;
    const check = () => {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.shouldShowBanner !== 'function') return false;
      try {
        if (!cp.shouldShowBanner() || gekozen(cp)) { een(); return true; }
        document.addEventListener('visitorConsentCollected', een, { once: true });
        // vangnet als de klik op de banner het event mist: elke 2 seconden kijken (max. 10 minuten)
        if (!wachten) { let n = 0; wachten = setInterval(() => { if (gedaan || gekozen(cp) || ++n > 300) { clearInterval(wachten); if (!gedaan && n <= 300) een(); } }, 2000); }
      } catch (e) { een(); }
      return true;
    };
    if (check()) return;
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => { if (!check()) een(); });
      setTimeout(() => { if (!gedaan && !check()) een(); }, 8000);
    } else {
      een();
    }
  }
  naBanner(start);
})();
